import { useState } from 'react';
import GridPreviewModal from '../GridPreviewModal/GridPreviewModal';
import styles from "./ProductField.module.css"
import FileBlock from "./FileBlock";
import HowToUse from "./HowToUse";
import { buildProductAnalyticsProps, capture } from "../../analytics";

const ProductField = ({ singleProduct, handleButtonClick, activeButton }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const fallbackPreviewUrl = singleProduct?.preview_url ?? null;
  const [activePreviewUrl, setActivePreviewUrl] = useState(null);

  const handleTabClick = (buttonName) => {
    if (buttonName !== activeButton) {
      capture(
        buttonName === "Assets" ? "product_assets_tab_opened" : "product_how_to_use_tab_opened",
        buildProductAnalyticsProps(singleProduct),
      );
    }
    handleButtonClick(buttonName);
  };

  const handlePreviewClick = (nextPreviewUrl, asset) => {
    capture("preview_opened", {
      ...buildProductAnalyticsProps(singleProduct),
      asset_id: asset?.id,
      asset_type_slug: asset?.asset_type?.slug,
      preview_source: nextPreviewUrl ? "asset_or_format" : "product",
    });
    setActivePreviewUrl(nextPreviewUrl || fallbackPreviewUrl);
    setPreviewOpen(true);
  };

  return (
    <>
      <section className="height" id="assets">
        <div className={styles.main} data-assets-scroll-anchor>
          <div className={styles.toggleCont}>
            <button
              className={`${styles.toggleBtn} ${activeButton === "Assets" ? styles.active : ""}`}
              onClick={() => handleTabClick("Assets")}
            >
              Assets
            </button>
            <button
              className={`${styles.toggleBtn} ${activeButton === "How to use" ? styles.active : ""}`}
              onClick={() => handleTabClick("How to use")}
            >
              How to use
            </button>
          </div>

          {activeButton === "Assets" && (
            <FileBlock
              singleProduct={singleProduct}
              previewUrl={fallbackPreviewUrl}
              onPreviewClick={handlePreviewClick}
            />
          )}
          {activeButton === "How to use" && <HowToUse />}
        </div>
      </section>
      {(activePreviewUrl || fallbackPreviewUrl) && (
        <GridPreviewModal
          isOpen={previewOpen}
          onClose={() => {
            setPreviewOpen(false);
            setActivePreviewUrl(null);
          }}
          previewUrl={activePreviewUrl || fallbackPreviewUrl}
        />
      )}
    </>
  );
};

export default ProductField
